<template>
  <div class="lb">
    <div class="map_box">
      <div id="world-map" class="mapMian" ref="mapMian"></div>
    </div>

    <!-- <div class="miaobian">
      <img class="mapImg" src="../../assets/temimg6/miaobian.png" alt />
    </div> -->
    <!-- <div class="map_nanhai">
      <img src="../../assets/temimg6/nanhai_map.png" alt />
    </div> -->
    <!-- <div class="legend">
      <div class="legend_left">
        <p>【图例说明】</p>
        <div><img src="../../assets/temimg12/point_icon.png" alt />园区</div>
      </div>
    </div> -->

    <!-- 新增的弹出窗口   popupData -->
    <div
      v-if="showPopup"
      class="popup"
      :style="{ top: popupTop + 'px', left: popupLeft + 'px' }"
    >
      <div class="dialog_main">
        <p class="title" :title="popupData.value2">{{ popupData.value2 }}</p>
      </div>
      <div class="dialog_item">
        <div class="dialog_box">
          <div>
            <p class="dialog_text" :title="popupData.value3">
              {{ popupData.value3 }}
            </p>
            <p :title="popupData.value4" v-if="popupData.value4">
              ({{ popupData.value4 }})
            </p>
          </div>
          <span class="dialog_right">{{ numformat(popupData.value5) }}</span>
        </div>
        <div class="dialog_box">
          <div>
            <p class="dialog_text" :title="popupData.value6">
              {{ popupData.value6 }}
            </p>
            <p :title="popupData.value7" v-if="popupData.value7">
              ({{ popupData.value7 }})
            </p>
          </div>
          <span class="dialog_right">{{ numformat(popupData.value8) }}</span>
        </div>
        <div class="dialog_box">
          <div>
            <p class="dialog_text" :title="popupData.value9">
              {{ popupData.value9 }}
            </p>
            <p :title="popupData.value10" v-if="popupData.value10">
              ({{ popupData.value10 }})
            </p>
          </div>
          <span class="dialog_right">{{ numformat(popupData.value11) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import chinaJson from "./china.json";
import * as methods from "../scope/method.js";
export default {
  name: "template.scope1.center6",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "中国地图示例",
      timer2: null,
      autoTimePaused: false,
      defaultdata: [
        {
          value1: "北京市",
          value2: "北京市",
          value3: "本周案例数",
          value4: "个",
          value5: "0",
          value6: "本月案例数",
          value7: "个",
          value8: "0",
          value9: "近一年案例数",
          value10: "个",
          value11: "0",
        },
        {
          value1: "安徽省",
          value2: "安徽省",
          value3: "本周案例数",
          value4: "个",
          value5: "0",
          value6: "本月案例数",
          value7: "个",
          value8: "0",
          value9: "近一年案例数",
          value10: "个",
          value11: "0",
        },
        {
          value1: "河南省",
          value2: "河南省",
          value3: "本周案例数",
          value4: "个",
          value5: "0",
          value6: "本月案例数",
          value7: "个",
          value8: "0",
          value9: "近一年案例数",
          value10: "个",
          value11: "0",
        },
      ],
      valueMap: [
        { name: "地区", key: "value1" },
        { name: "名称", key: "value2" },
        { name: "数据一", key: "value3" },
        { name: "标注一", key: "value4" },
        { name: "数值一", key: "value5" },
        { name: "数据二", key: "value6" },
        { name: "标注二", key: "value7" },
        { name: "数值二", key: "value8" },
        { name: "数据三", key: "value9" },
        { name: "标注三", key: "value10" },
        { name: "数值三", key: "value11" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      config: {},
      showPopup: false, // 控制弹出窗口的显示和隐藏
      popupData: null, // 存储要显示的数据
      popupTop: 0, // 弹窗的 top 位置
      popupLeft: 0, // 弹窗的 left 位置
      currentIndex: 0, // 当前轮播数据的索引
      targetName: "", // 要高亮显示的名称
      defaultSymbol:
        "image://" + require("../../assets/temimg6/point_icon_grey.png"),
      activeSymbol:
        "image://" + require("../../assets/temimg6/point_icon.png"), // 替换为你想要的激活状态图片路径
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n.filter(
          (item) => item && item[this.valueMap[0].key]
        );
        // 如果有数据变化，可以在这里处理数据并更新地图
      }
    },
    jsondata(n) {
      this.exceldata = n;
      // 如果有数据变化，可以在这里处理数据并更新地图
    },
    defaultdata(n) {
      this.DrawEcharts();
    }
  },
  beforeDestroy() {
    const TmyChart = echarts.init(this.$refs.mapMian);
    TmyChart.clear();
    clearInterval(this.timer2);
    this.timer2 = null;
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer2);
      this.timer2 = null;
      const echarts = require("echarts");
      const TmyChart = echarts.init(this.$refs.mapMian);
      let serdata = chinaJson.features
            .filter((item) => {
              return this.defaultdata.some(
                (defaultItem) => defaultItem.value1 === item.properties.name
              );
            })
            .map((item) => ({
              name: item.properties.name,
              value: item.properties.centroid,
            }))
      const Toption = {
        width: 800,
        height: 820,
        geo: [
          {
            map: "china",
            aspectScale: 1,
            zoom: 1,
            top: "-4%",
            left: "7%",
            roam: false,
            regions: [
              {
                name: "南海诸岛",
                itemStyle: {
                  normal: {
                    opacity: 0,
                  },
                },
                label: {
                  show: false,
                },
              },
            ],
            tooltip: {
              show: false,
              // color: "transparent",
            },
            label: {
              show: false,
              emphasis: {
                show: false,
                color: "transparent",
              },
            },
            itemStyle: {
              normal: {
                areaColor: "transparent",
                borderColor: "transparent",
              },
              emphasis: {
                areaColor: "transparent",
              },
            },
          },
        ],
        series: [
          {
            type: "map",
            map: "china",
            zoom: 1,
            top: "-4%",
            left: "7%",
            roam: false,
            selectedMode: false,
            regions: [
              {
                name: "南海诸岛",
                itemStyle: {
                  normal: {
                    opacity: 0,
                  },
                },
                label: {
                  show: false,
                },
              },
            ],
            label: {
              show: true,
              color: "#FFF",
              fontSize: 14,
              formatter: function (params) {
                if (params.name === "南海诸岛") {
                  return "";
                }
              },
              emphasis: {
                color: "#FFF",
                fontSize: 14,
              },
            },
            itemStyle: {
              normal: {
                areaColor: "transparent",
                borderColor: "transparent",
              },
              emphasis: {
                areaColor: "transparent",
              },
            },
            zlevel: 5,
            data: this.defaultdata.map((item) => ({
              name: item.value1,
              value: item.value2,
            })),
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            data: serdata,
            // symbolKeepAspect: true,
            // effectType: "none",
            // symbol: this.defaultdata.some(item => item.value1 == this.targetName) ? this.activeSymbol : this.defaultSymbol, // 设置图片路径,
            symbol: this.defaultSymbol, // 设置图片路径
            symbolSize: [50, 80], // 设置图片大小
            rippleEffect: {
              number: 1,
              scale: 1,
              // period:5,
              color: "transparent",
              show: false, // 关闭涟漪特效
            },
            label: {
              show: false,
            },
            itemStyle: {
              color: "transparent",
            },
            zlevel: 6,
          },
        ],
      };

      echarts.registerMap("china", chinaJson);
      Toption && TmyChart.setOption(Toption);
      this.timer2 = setInterval(() => {
        
        if (this.currentIndex >= this.defaultdata.length) {
          this.currentIndex = 0;
        }
      
        const targetData = this.defaultdata[this.currentIndex];

        if (targetData) {
          this.showPopup = true;
          this.popupData = targetData;

          this.targetName = targetData.value1;
          const targetPoint = chinaJson.features.find(
            (item) => item.properties.name === this.targetName
          );

          if (targetPoint) {
            const point = targetPoint.properties.centroid;
            const pointInPixel = TmyChart.convertToPixel("geo", point);
            this.popupLeft = pointInPixel[0] + 10;
            this.popupTop = pointInPixel[1] - 10;

            // 更新 series 数据中的 symbol
            const seriesData = TmyChart.getOption().series[1].data;
            seriesData.forEach((dataItem) => {
              dataItem.symbol =
                dataItem.name === this.targetName
                  ? this.activeSymbol
                  : this.defaultSymbol;
            });
            // 重新设置 echarts 实例的选项
            TmyChart.setOption({
              series: [
                ...TmyChart.getOption().series.slice(0, 1),
                {
                  type: "effectScatter",
                  data: seriesData,
                },
              ],
            });
          } else {
            this.showPopup = false;
          }
        } else {
          this.showPopup = false;
        }

        this.currentIndex++;
      }, 5000);
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    console.log(this.config);
    
    this.setData();
    this.DrawEcharts();
  },
};
</script>

<style scoped lang="scss">
.lb {
  // width: 874px;
  height: 542px;
  position: relative;
  z-index: 5;
  pointer-events: auto;
}
.map_box {
  width: 874px;
  height: 874px;
  position: relative;
  z-index: 5;
  padding: 10px 0;
  overflow: hidden;
  pointer-events: auto;
}
.mapMian {
  top: -6px;
  left: 8px;
  width: 100%;
  height: 100%;
  // width: 1127px;
  // height: 1030px;
  position: relative;
  z-index: 20;
}
.miaobian {
  width: 972px;
  height: 972px;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 2;
}

.map_nanhai {
  position: absolute;
  right: 10%;
  bottom: 16%;
  z-index: 10;
  width: 98px;
  height: 138px;
  img {
    width: 100%;
    height: 100%;
  }
}
.legend {
  position: absolute;
  bottom: 0%;
  right: 0%;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 30px;

  img {
    width: 39px;
    height: 55px;
  }
}
.mapImg {
  width: 1920px;
  height: 1080px;
  position: absolute;
  top: -14%;
  left: -48.8%;
  z-index: 3;
}
.mapline {
  width: 790px;
  height: 586px;
  position: absolute;
  top: 8%;
  left: 9%;
  z-index: 4;
}
.popup {
  width: 202px;
  height: 97px;
  position: absolute;
  background: url("../../assets/temimg12/Dialog.png") no-repeat;
  background-size: 100% 100%;
  color: white;
  /* padding: 10px; */
  /* border-radius: 5px; */
  z-index: 55;

  .dialog_main {
    .title {
      margin: 2px 0 0 10px;
      width: 110px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: pmzd;
      font-weight: 400;
      font-size: 14px;
      color: #f0f0f0;
      cursor: pointer;
    }
  }

  .dialog_item {
    margin: 0px 0 0 9px;
  }
  .dialog_box {
    cursor: pointer;
    padding: 0 6px;
    width: 180px;
    height: 24px;
    // border: #68c2f9 1px solid;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #e1f1ff;
    line-height: 24px;
    font-family: Hei;
    font-weight: 400;
    font-size: 12px;
    div {
      display: flex;
    }
    p {
      max-width: 80px;
      // width: 60px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p:nth-child(2) {
      margin-left: 4px;
      max-width: 60px;
      // width: 40px;
    }
    // .dialog_text {

    // }
    .dialog_right {
      text-align: right;
      margin-left: 10px;
      display: block;
      text-align: right;
      font-family: BenmoZiyu;
      font-weight: 400;
      font-size: 14px;
      color: #68c2f9;
    }
  }
}
</style>
